import {Inject, Injectable} from '@angular/core';
import {Config, CONFIG} from "@nx-averycom/environment";
import {has, isEmpty} from "lodash-es";
import {UserInfoInterface} from "@nx-averycom/shared/avry-models";
import {BrowserAbstractionService} from "./browser-abstraction.service";
import {WindowService} from "@nx-averycom/shared/browser";
import {DOCUMENT} from "@angular/common";

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {
  constructor(
    @Inject(CONFIG) private config: Config,
    private browser: BrowserAbstractionService,
    @Inject(DOCUMENT) private _doc: Document,
    private windowService: WindowService,
  ) { }

  emitCoreDataLayer() {
    const path = this._doc.location.pathname.split('/');
    path.shift();
    const consumerData: UserInfoInterface = this.browser.localStorageGetter('u_i');
    const dataLayer = (<any>this.windowService.getWindow()).dataLayer;
    if (dataLayer) {
      dataLayer.push({
        event: 'dataLayer-initialized',
        siteVersion: this.config.version,
        language: 'en_us',
        id: has(consumerData, 'consumerId') ? consumerData.consumerId : undefined,
        customerType: undefined,
        loggedIn: !isEmpty(consumerData),
        pageType: this.determinePageType(path),
      });
    }

  }

  determinePageType(path: string[] = []): string | undefined {
    switch (path[0]) {
      case 'blank': {
        if (
          path[1] === 'shape' ||
          path[1] === 'usage' ||
          path[1] === 'material'
        ) {
          return 'List Page';
        } else if (path[1] === 'labels' && path.length === 3) {
          return 'Product Page';
        }
        break;
      }
      case 'custom-printing': {
        if (path[1] === 'predesign') {
          return 'List Page';
        } else if (path[1] === 'labels' && path[2] === 'calculator') {
          return 'Product Page';
        }
        break;
      }
      case 'myaccount': {
        if (path[1] === 'projects') {
          return 'MyAccount Project Page';
        } else if (path[1] === 'files') {
          return 'MyAccount File Page';
        } else if (path[1] === 'final-print-templates') {
          return 'MyAccount Final Print Templates Page';
        } else if (path[1] === 'orders') {
          return 'MyAccount Order Page';
        } else if (path[1] === 'profile') {
          return 'MyAccount Profile Page';
        } else {
          return 'MyAccount Page';
        }
      }
      case 'predesign': {
        if (path.length === 3) {
          return 'List Page';
        }
        break;
      }
      case 'products': {
        if (
          path.length === 2 ||
          ((path[1] === 'labels' || path[1] === 'cards') && path.length > 3)
        ) {
          return 'List Page';
        } else if (path.length === 3) {
          return 'Product Page';
        }
        break;
      }
      case 'srch': {
        return 'Search Page';
      }
      case 'templates': {
        if (path[1] === 'category') {
          return 'List Page';
        } else if (path.length === 2) {
          return 'Product Page';
        }
        break;
      }
    }

    return undefined;
  }

  pushDataLayer(obj: any = {}) {
    (<any>this.windowService.getWindow()).dataLayer = (<any>this.windowService.getWindow()).dataLayer || [];
    (<any>this.windowService.getWindow()).dataLayer.push(obj);
  }
}
